/**
 * Console Control Utility
 * Disables console logging in production for all users except test accounts
 */

// Store original console methods
const originalConsole = {
  log: console.log,
  debug: console.debug,
  info: console.info,
  warn: console.warn,
  // Keep error available for critical issues
  error: console.error
};

// Test accounts that should have console logging enabled
const ALLOWED_TEST_ACCOUNTS = new Set([
  'employee@test.com',
  'admin@test.com',
  'hr@test.com'
]);

let isConsoleEnabled = false;
let currentUserEmail = null;

/**
 * Check if console should be enabled for the current user
 */
function shouldEnableConsole(userEmail) {
  if (!userEmail) return false;
  return ALLOWED_TEST_ACCOUNTS.has(userEmail.toLowerCase());
}

/**
 * Enable console logging
 */
function enableConsole() {
  if (isConsoleEnabled) return;
  
  console.log = originalConsole.log;
  console.debug = originalConsole.debug;
  console.info = originalConsole.info;
  console.warn = originalConsole.warn;
  console.error = originalConsole.error;
  
  isConsoleEnabled = true;
}

/**
 * Disable console logging (except errors)
 */
function disableConsole() {
  if (!isConsoleEnabled) return;
  
  // Create no-op functions
  const noop = () => {};
  
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
  // Keep console.error enabled for critical issues
  
  isConsoleEnabled = false;
}

/**
 * Update console state based on user
 */
export function updateConsoleForUser(userEmail) {
  currentUserEmail = userEmail;
  
  if (shouldEnableConsole(userEmail)) {
    enableConsole();
    originalConsole.log('[Console] Enabled for test account:', userEmail);
  } else {
    disableConsole();
    // Use original console.log to show this message even when disabled
    originalConsole.log('[Console] Disabled for production user. Console access restricted to test accounts only.');
  }
}

/**
 * Initialize console control on app start
 */
export function initializeConsoleControl() {
  // Start with console disabled by default
  disableConsole();
  originalConsole.log('[Console] Console control initialized. Logging disabled by default.');
}

/**
 * Get the original console for internal use
 */
export function getOriginalConsole() {
  return originalConsole;
}
